/* @ts-ignore */
import * as Types from '../generated/graphql.g';

export type ErrorFragment = { __typename: 'ErrorType', field?: string | null, message?: string | null };


export const ErrorFragmentDoc = `
    fragment Error on ErrorType {
  field
  message
}
    `;